// eslint-disable-next-line no-unused-vars
import Interaction from '@/models/general/interaction'

export default {
  methods: {
    /**
     * Handle interaction based on type
     * @param {Interaction} interaction
     */
    handleInteraction(interaction) {
      if (!interaction.isInteractionPossible()) return

      if (interaction.isEmitEvent()) {
        const emitEvent = interaction.getEmitEvent()
        if (emitEvent.disabled) return null
        return this.$emit(emitEvent.event, emitEvent.value)
      }

      if (interaction.isRouterLink()) {
        const routerLink = interaction.getRouterLink()
        return this.$router.push(routerLink)
      }

      if (interaction.isExternalLink()) {
        const externalLink = interaction.getExternalLink()
        return window.open(externalLink, '_blank')
      }

      if (interaction.isFunction()) {
        const func = interaction.getFunction()
        return func()
      }
    },
  },
}
